var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path9, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path10, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinemaxLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.63,
    height: 93.4,
    viewBox: "0 0 247.63 93.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19,75.73c0-11.54,7.56-20.33,20.38-20.33a22.28,22.28,0,0,1,9.24,1.68V67.67a16.13,16.13,0,0,0-9-2.46C18,65.2,14.43,70.13,14.43,76c0,6.83,3.58,12.1,11.54,12.1a15,15,0,0,0,8.85-2.58v9a20.71,20.71,0,0,1-9.24,2C12.7,96.4,5.19,88.22,5.19,75.73Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.26,56.3H50.5V95.5H41.26Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.66,56.3V95.5H83.37l-16-25.31V95.5H58.79V56.3H68L83,79.93V56.3Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.66,88.16V95.5H99.94V56.3H126.1V65H109.18v7.39h15.9v7.34h-15.9v8.4Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.08,56.3V95.5H164.4V70.36l-7.11,13.83H149l-7.06-13.55V95.5h-8.68V56.3H143.4l10,18.48,10-18.48Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.16,88.72h-15l-2.3,6.78h-9.3l13.66-39.2h10.92l13.66,39.2h-9.35Zm-2.58-7.62-4.93-14.67-5,14.67Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.56,76.07,252.82,95.5h-10.3l-8.18-13.27-8,13.27h-10l12.32-19.77L216.31,56.3h10.3l8.23,13.21,8-13.21h10Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.65,4c-3.51,3.41-13.87,14.77-14.54,30.59a1.85,1.85,0,0,0,1.53,1.91c3.36.57,11.29,1.53,15.53-1.27a1.83,1.83,0,0,0,.77-1.94c-.86-3.73-2.89-16.3,5.81-26.14a1.84,1.84,0,0,0-.44-2.82A13.37,13.37,0,0,0,120.39,3,3.67,3.67,0,0,0,117.65,4Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.91,
    y: 30.41,
    width: 3.02,
    height: 4.23,
    rx: 1,
    ry: 1,
    transform: "translate(-1.45 -13.48) rotate(5.68)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.14,
    y: 25.34,
    width: 2.42,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(1.89 -22.98) rotate(10.89)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 21.48,
    width: 2.12,
    height: 3.02,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(9.02 -38.65) rotate(19.76)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110.17,
    y: 17.97,
    width: 1.81,
    height: 2.72,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(9.09 -41.48) rotate(20.98)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111.83,
    y: 14.57,
    width: 1.81,
    height: 2.42,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(11.73 -48.69) rotate(24.72)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 113.67,
    y: 11.23,
    width: 1.81,
    height: 2.12,
    rx: 0.81,
    ry: 0.81,
    transform: "translate(16.3 -58.64) rotate(30)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.68,
    y: 8.14,
    width: 1.81,
    height: 1.81,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(25.43 -73.23) rotate(38.24)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.95,
    y: 5.61,
    width: 1.51,
    height: 1.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(24.22 -75.11) rotate(38.24)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113.44,
    y: 30.84,
    width: 3.02,
    height: 4.23,
    rx: 1,
    ry: 1,
    transform: "translate(-4.45 -5.49) rotate(1.24)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 114.25,
    y: 25.72,
    width: 2.42,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(-1.37 -15.8) rotate(6.45)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115.19,
    y: 21.78,
    width: 2.12,
    height: 3.02,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(5.09 -32.89) rotate(15.32)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 116.67,
    y: 18.16,
    width: 1.81,
    height: 2.72,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(5.23 -35.66) rotate(16.54)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 118.05,
    y: 14.64,
    width: 1.81,
    height: 2.42,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(7.67 -43.25) rotate(20.28)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 119.61,
    y: 11.16,
    width: 1.81,
    height: 2.12,
    rx: 0.81,
    ry: 0.81,
    transform: "translate(11.88 -53.81) rotate(25.56)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 121.37,
    y: 7.94,
    width: 1.81,
    height: 1.81,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(20.4 -69.54) rotate(33.81)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 123.42,
    y: 5.25,
    width: 1.51,
    height: 1.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(19.14 -71.08) rotate(33.81)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.77,35.16c-1.27-4.72-6.16-19.3-19.66-27.58A1.85,1.85,0,0,0,130.7,8c-2.13,2.66-6.83,9.12-6.44,14.18a1.83,1.83,0,0,0,1.32,1.61c3.68,1.06,15.65,5.4,20,17.79a1.84,1.84,0,0,0,2.67,1,13.37,13.37,0,0,0,4.06-4.51A3.67,3.67,0,0,0,152.77,35.16Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 131.33,
    y: 10.25,
    width: 3.02,
    height: 4.23,
    rx: 1,
    ry: 1,
    transform: "translate(213.58 -92.7) rotate(124.78)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 135.88,
    y: 13.97,
    width: 2.42,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(232.07 -82.11) rotate(129.99)",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 139.12,
    y: 17.27,
    width: 2.12,
    height: 3.02,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(252.91 -62.31) rotate(138.85)",
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 20.61,
    width: 1.81,
    height: 2.72,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(260.85 -55.7) rotate(140.07)",
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 143.98,
    y: 23.94,
    width: 1.81,
    height: 2.42,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(271.49 -43.09) rotate(143.81)",
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 146.14,
    y: 27.4,
    width: 1.81,
    height: 2.12,
    rx: 0.81,
    ry: 0.81,
    transform: "translate(282.64 -25.65) rotate(149.1)",
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 147.99,
    y: 30.88,
    width: 1.81,
    height: 1.81,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(293.35 0.76) rotate(157.34)",
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 149.46,
    y: 34.18,
    width: 1.51,
    height: 1.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(297.1 6.31) rotate(157.34)",
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 127.29,
    y: 16.62,
    width: 3.02,
    height: 4.23,
    rx: 1,
    ry: 1,
    transform: "translate(204.85 -85.96) rotate(120.34)",
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 132.09,
    y: 20,
    width: 2.42,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(223.35 -76.95) rotate(125.55)",
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 135.56,
    y: 23.06,
    width: 2.12,
    height: 3.02,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(244.59 -58.81) rotate(134.42)",
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 138.36,
    y: 26.2,
    width: 1.81,
    height: 2.72,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(252.91 -53.11) rotate(135.64)",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 29.35,
    width: 1.81,
    height: 2.42,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(264.13 -41.58) rotate(139.38)",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 143.31,
    y: 32.62,
    width: 1.81,
    height: 2.12,
    rx: 0.81,
    ry: 0.81,
    transform: "matrix(-0.82, 0.58, -0.58, -0.82, 276.14, -25.26)",
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 145.41,
    y: 35.95,
    width: 1.81,
    height: 1.81,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(288.16 0.03) rotate(152.9)",
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 147.11,
    y: 39.15,
    width: 1.51,
    height: 1.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(292.49 5.07) rotate(152.9)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.4,49.74c4.76,1.11,19.92,3.71,33.6-4.27a1.85,1.85,0,0,0,.78-2.32C141.45,40,138,32.82,133.34,30.76a1.83,1.83,0,0,0-2,.4c-2.68,2.74-12.17,11.23-25.15,9.21A1.84,1.84,0,0,0,104,42.26,13.37,13.37,0,0,0,106.06,48,3.67,3.67,0,0,0,108.4,49.74Z",
    transform: "translate(-5.19 -3)",
    fill: "#ff2c37"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 136.4,
    y: 40.85,
    width: 3.02,
    height: 4.23,
    rx: 1,
    ry: 1,
    transform: "translate(157 182.37) rotate(-116.98)",
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 131.68,
    y: 43.27,
    width: 2.42,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(135.12 182.23) rotate(-111.77)",
    fill: "#fff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 127.73,
    y: 44.88,
    width: 2.12,
    height: 3.02,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(107.13 179.29) rotate(-102.91)",
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 123.93,
    y: 45.65,
    width: 1.81,
    height: 2.72,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(98.89 175.78) rotate(-101.69)",
    fill: "#fff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 120.04,
    y: 46.32,
    width: 1.81,
    height: 2.42,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(85.4 170.89) rotate(-97.95)",
    fill: "#fff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 116.11,
    y: 46.81,
    width: 1.81,
    height: 2.12,
    rx: 0.81,
    ry: 0.81,
    transform: "translate(69.44 163.98) rotate(-92.66)",
    fill: "#fff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 47.01,
    width: 1.81,
    height: 1.81,
    rx: 0.7,
    ry: 0.7,
    transform: "matrix(0.1, -1, 1, 0.1, 49.31, 152.93)",
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 109.05,
    y: 46.83,
    width: 1.51,
    height: 1.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(46.57 149.25) rotate(-84.42)",
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 34.28,
    width: 3.02,
    height: 4.23,
    rx: 1,
    ry: 1,
    transform: "translate(167.92 166.9) rotate(-121.42)",
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 128.16,
    y: 37.08,
    width: 2.42,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(146.42 169.14) rotate(-116.21)",
    fill: "#fff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 124.31,
    y: 39.01,
    width: 2.12,
    height: 3.02,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(118.87 169.27) rotate(-107.34)",
    fill: "#fff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 120.58,
    y: 40.08,
    width: 1.81,
    height: 2.72,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(110.22 166.65) rotate(-106.12)",
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 116.74,
    y: 41.05,
    width: 1.81,
    height: 2.42,
    rx: 0.91,
    ry: 0.91,
    transform: "translate(96.41 163.23) rotate(-102.38)",
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 112.85,
    y: 41.84,
    width: 1.81,
    height: 2.12,
    rx: 0.81,
    ry: 0.81,
    transform: "translate(80.05 158.08) rotate(-97.1)",
    fill: "#fff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 109.05,
    y: 42.34,
    width: 1.81,
    height: 1.81,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(59.33 149.32) rotate(-88.86)",
    fill: "#fff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 105.79,
    y: 42.42,
    width: 1.51,
    height: 1.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(56.05 145.84) rotate(-88.86)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemaxLogoRed);
export default __webpack_public_path__ + "static/media/Cinemax_Logo_Red.feea66b2a7e64d8365c67ee87acf5715.svg";
export { ForwardRef as ReactComponent };